var _g, _polygon, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRadarDefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 330,
    height: 330,
    viewBox: "0 0 330 330",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#DADADA",
    strokeWidth: 1,
    fill: "none"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "165,25 264,61 305,165 264,269 165,305 66,269 25,165 66,61"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165,60 239,87 270,165 239,243 165,270 91,243 60,165 91,87"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165,95 214,113 235,165 214,217 165,235 116,217 95,165 116,113"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165,130 189,139 200,165 189,191 165,200 141,191 130,165 141,139"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 165,
    y1: 165,
    x2: 165,
    y2: 25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 165,
    y1: 165,
    x2: 264,
    y2: 61
  }), /*#__PURE__*/React.createElement("line", {
    x1: 165,
    y1: 165,
    x2: 305,
    y2: 165
  }), /*#__PURE__*/React.createElement("line", {
    x1: 165,
    y1: 165,
    x2: 264,
    y2: 269
  }), /*#__PURE__*/React.createElement("line", {
    x1: 165,
    y1: 165,
    x2: 165,
    y2: 305
  }), /*#__PURE__*/React.createElement("line", {
    x1: 165,
    y1: 165,
    x2: 66,
    y2: 269
  }), /*#__PURE__*/React.createElement("line", {
    x1: 165,
    y1: 165,
    x2: 25,
    y2: 165
  }), /*#__PURE__*/React.createElement("line", {
    x1: 165,
    y1: 165,
    x2: 66,
    y2: 61
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "165,75 240,100 250,165 210,240 165,255 105,220 85,165 125,110",
    fill: "#EFEFEF",
    fillOpacity: 0.75,
    stroke: "#565656",
    strokeWidth: 1.5
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#565656"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 165,
    cy: 75,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 100,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 165,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 240,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 165,
    cy: 255,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 105,
    cy: 220,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 165,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 110,
    r: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadarDefault);
export default __webpack_public_path__ + "static/media/radarDefault.304f79f1ffd0c7d59486c494144c2e1e.svg";
export { ForwardRef as ReactComponent };